<form [formGroup]="form">
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">{{titleModal}}</h4>
        <button type="button" class="close btn-close" aria-label="Close" (click)="closeModal()">
        </button>
    </div>

    <ng-container>
        <div class="modal-body mx-sm-5">
            <div class="row" *ngIf="isSapMode">
                <div class="col-6">
                     วันที่ให้ธนาคารโอนเงิน
                    <div class="input-group">
                        <input type="text" class="form-control" placeholder="yyyy-mm-dd" name="dp" ngbDatepicker
                               readonly="true" #ddateEffective="ngbDatepicker" formControlName="dateEffective"
                               [ngClass]="{'is-invalid': form.controls.dateEffective.invalid && form.controls.dateEffective.touched}">
                        <span class="input-group-text fa fa-calendar cursor-pointer" id="basic-addon2"
                              (click)="ddateEffective.toggle()"></span>
                        <div *ngIf="form.controls.dateEffective.invalid && form.controls.dateEffective.touched">
                            <label class="col-form-label" style="color: red;">กรุณาระบุ วันที่ให้ธนาคารโอนเงิน</label>
                        </div>
                    </div>

                </div>
            </div>
            <div class="row" *ngIf="isSpecificMonth">
                <div class="col-6">
                    เดือนเริ่มต้น
                    <div class="input-group">
                        <input type="text" class="form-control" placeholder="yyyy-mm-dd" name="dp" ngbDatepicker
                            readonly="true" #dstartDate="ngbDatepicker" formControlName="startDate"
                            [ngClass]="{'is-invalid': form.controls.startDate.invalid && form.controls.startDate.touched}">
                        <span class="input-group-text fa fa-calendar cursor-pointer" id="basic-addon2"
                            (click)="dstartDate.toggle()"></span>
                        <div *ngIf="form.controls.startDate.invalid && form.controls.startDate.touched">
                            <label class="col-form-label" style="color: red;">กรุณาระบุ Start Date</label>
                        </div>
                    </div>


                </div>
                <div class="col-6">
                    ถึงเดือน
                    <div class="input-group">
                        <input type="text" class="form-control" placeholder="yyyy-mm-dd" name="dp" ngbDatepicker
                            readonly="true" #dendDate="ngbDatepicker" formControlName="endDate"
                            [minDate]="form.get('startDate').value"
                            [ngClass]="{'is-invalid': form.controls.endDate.invalid && form.controls.endDate.touched}">
                        <span class="input-group-text fa fa-calendar cursor-pointer" id="basic-addon2"
                            (click)="dendDate.toggle()"></span>
                        <div *ngIf="form.controls.endDate.invalid && form.controls.endDate.touched">
                            <label class="col-form-label" style="color: red;">กรุณาระบุ End Date</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>

    <div class="modal-footer">
        <ng-container>
            <div class="col-6 col-md-3">
                <button id="btn-submit" type="button" class="btn btn-blue form-control"
                    (click)="exportIncomeByMonth()">{{submitButtonLabel}}</button>
            </div>
        </ng-container>
    </div>
</form>
